export const UPDATE_ATTACHMENT = 'MULTIPLE/UPDATE_ATTACHMENT'
export const UPDATE_BOOKINGS = 'MULTIPLE/UPDATE_BOOKINGS'
export const UPDATE_LOCATION_ID = 'MULTIPLE/UPDATE_LOCATION_ID'
export const CHANGE_CURRENT_STEP = "CHANGE_CURRENT_STEP"
export const UPDATE_COMPANY_SETTING = 'MULTIPLE/UPDATE_COMPANY_SETTING'
export const UPDATE_BADGE = 'MULTIPLE/UPDATE_BADGE'
export const UPDATE_BATCH = 'MULTIPLE/UPDATE_BATCH'
